import { render, staticRenderFns } from "./cube.vue?vue&type=template&id=a671f838&scoped=true&"
import script from "./cube.vue?vue&type=script&lang=js&"
export * from "./cube.vue?vue&type=script&lang=js&"
import style0 from "./cube.vue?vue&type=style&index=0&id=a671f838&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a671f838",
  null
  
)

export default component.exports